<template>
    <page-header-wrapper>
      <a-card :bordered="false">
        <!-- 操作 -->
        <div class="table-operations">
          <a-button type="primary" @click="$refs.createForm.handleAdd()">
            <a-icon type="plus" />新增
          </a-button>
        </div>
        <create-form
            ref="createForm"
            @ok="getList"
        />
        <!-- 数据展示 -->
        <a-table
          :loading="loading"
          rowKey="id"
          :columns="columns"
          :data-source="list"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :pagination="false"
          :bordered="tableBordered"
        >
          <span slot="sendTime" slot-scope="text, record">
            {{ parseTime(record.sendTime) }}
          </span>
          <span slot="operation" slot-scope="text, record">
            <a @click="$refs.createForm.handleUpdate(record)">
              <a-icon type="edit" />修改
            </a>
            <a-divider type="vertical" />
            <a @click="handleDelete(record)">
              <a-icon type="delete" />删除
            </a>
          </span>
        </a-table>
        <!-- 分页 -->
        <a-pagination
          class="ant-table-pagination"
          show-size-changer
          show-quick-jumper
          :current="queryParam.pageNum"
          :total="total"
          :page-size="queryParam.pageSize"
          :showTotal="total => `共 ${total} 条`"
          @showSizeChange="onShowSizeChange"
          @change="changeSize"
        />
      </a-card>
    </page-header-wrapper>
  </template>
  
  <script>
  import { pagePush, listPush, delPush } from '@/api/video/emailPush'
  import CreateForm from './modules/CreateForm'
  import { tableMixin } from '@/store/table-mixin'
  
  export default {
    name: 'Push',
    components: {
      CreateForm
    },
    mixins: [tableMixin],
    data () {
      return {
        list: [],
        selectedRowKeys: [],
        selectedRows: [],
        // 高级搜索 展开/关闭
        advanced: false,
        // 非单个禁用
        single: true,
        // 非多个禁用
        multiple: true,
        ids: [],
        loading: false,
        total: 0,
        // 查询参数
        queryParam: {
          content: null,
          toPage: null,
          toUser: null,
          timeType: null,
          sendTime: null,
          pageNum: 1,
          pageSize: 10
        },
        columns: [
          {
            title: '标题',
            dataIndex: 'subject',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '内容',
            dataIndex: 'content',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '发送时间',
            dataIndex: 'sendTime',
            scopedSlots: { customRender: 'sendTime' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '推送类型',
            dataIndex: 'pushType',
            ellipsis: true,
            align: 'center'
          },
          {
            title: '创建时间',
            dataIndex: 'createTime',
            scopedSlots: { customRender: 'createTime' },
            ellipsis: true,
            align: 'center'
          },
          {
            title: '操作',
            dataIndex: 'operation',
            width: '18%',
            scopedSlots: { customRender: 'operation' },
            align: 'center'
          }
        ]
      }
    },
    filters: {
    },
    created () {
      this.getList()
    },
    computed: {
    },
    watch: {
    },
    methods: {
      /** 查询平台推送列表 */
      getList () {
        this.loading = true
       pagePush(this.queryParam).then(response => {
          this.list = response.data.records
          this.total = response.data.total
          this.loading = false
        })
      },
  
      /** 搜索按钮操作 */
      handleQuery () {
        this.queryParam.pageNum = 1
        this.getList()
      },
      /** 重置按钮操作 */
      resetQuery () {
        this.queryParam = {
          content: undefined,
          toPage: undefined,
          toUser: undefined,
          timeType: undefined,
          sendTime: undefined,
          pageNum: 1,
          pageSize: 10
        }
        this.handleQuery()
      },
      onShowSizeChange (current, pageSize) {
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      changeSize (current, pageSize) {
        this.queryParam.pageNum = current
        this.queryParam.pageSize = pageSize
        this.getList()
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
        this.ids = this.selectedRows.map(item => item.id)
        this.single = selectedRowKeys.length !== 1
        this.multiple = !selectedRowKeys.length
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },
      /** 删除按钮操作 */
      handleDelete (row) {
        var that = this
        const ids = row.id || this.ids
        if (row.id) {
          this.ids.push(row.id)
        }
        this.$confirm({
          title: '确认删除所选中数据?',
          content: '当前选中编号为' + ids + '的数据',
          onOk () {
            const data = []
            that.ids.map(id => data.push({ 'id': id }))
            return delPush(data)
              .then(() => {
                that.onSelectChange([], [])
                that.getList()
                that.$message.success(
                  '删除成功',
                  3
                )
            })
          },
          onCancel () {
            // 取消清空删除ids列表
            that.ids = []
          }
        })
      },
      /** 导出按钮操作 */
      handleExport () {
        var that = this
        this.$confirm({
          title: '是否确认导出?',
          content: '此操作将导出当前条件下所有数据而非选中数据',
          onOk () {
            that.download('video/platform-push/export', {
              ...that.queryParam
            }, `平台推送_${new Date().getTime()}.xlsx`)
          },
          onCancel () {}
        })
      }
    }
  }
  </script>
  